
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CustomOverlay extends Vue {
    @Prop() loading!: boolean;
}
